import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Environement} from '../../../environement/environement';
import {removeAccents} from '../../partage/prototype/sansAccents';


@Injectable()
export class ListeOrganisationService {
  private listeOrganisationUrl = Environement.BASE_API_URL + '/api/liste_organisations';
  private organisationUrl =  Environement.BASE_API_URL + '/api/organisations';
  private listeOrganisationAssoUrl = Environement.BASE_API_URL + '/api/liste_organisation_organisations';
  constructor(private http: HttpClient) { }

  getListesOrganisationsParDefaut(page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '?_page=' + page + '&order[nom]=asc', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeOrganisation(listeOrganisation) {
    const DateCre = listeOrganisation.creation.getFullYear() + '-' + (listeOrganisation.creation.getMonth() + 1).toString() + '-' + listeOrganisation.creation.getDate() + ' ' + listeOrganisation.creation.getHours() + ':' + listeOrganisation.creation.getMinutes() + ':00' ;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeOrganisationUrl, {'nom': listeOrganisation.nom,
        'commentaires': listeOrganisation.commentaires, 'creation' : DateCre,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeOrganisation.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeOrganisationCopie(listeOrganisation) {
    let nom = '';
    nom = 'Copie de ' + listeOrganisation.nom;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeOrganisationUrl, {'nom': nom,
        'commentaires': listeOrganisation.commentaires, 'creation' : listeOrganisation.creation,
        'modification' : listeOrganisation.modification,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeOrganisation.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addOrganisationListe(listeId, organisationId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeOrganisationAssoUrl, {
        'listeOrganisation': this.listeOrganisationUrl + '/' + listeId,
        'organisation': this.organisationUrl + '/' + organisationId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  importerListeOrganisationIntranet(listeId, ancienId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '/importation/copie/liste/organisation/' + listeId + '/' + ancienId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  addAncienIdListeOrganisation(ancienIdListe, listeId) {
    const headers = this.initOptionHeader();
    return this.http.put(this.listeOrganisationUrl + '/' +  listeId, {'ancienId': ancienIdListe},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeOrganisationDetails(id): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '/' + id , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAncienIdAuteur(listeOrganisationId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '/auteur/intranet/' + listeOrganisationId , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllOrganisationsListe(listeId, page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.organisationUrl + '?listeOrganisationOrganisations.listeOrganisation.id=' + listeId + '&_page=' + page + '&order[nom]=asc', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllAssosListeOrganisation(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationAssoUrl + '?listeOrganisation.id=' + listeId , {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeOrganisationAllAssos(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationAssoUrl + '?pagination=false&listeOrganisation.id=' + listeId , {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  exporterListeOrganisation(listeId, id, nom, dirigeant, date, code, siren, forme, capital, effectif, implantation, genre,
                            categ, commentaire, premierTel, deuxiemeTel, email, rue, complement, bpostal, cpostal, ville,
                            pays, premierURL, deuxiemeURL) {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/statistique/exportation/liste/organisation/' + listeId + '/' + id + '/'
      + nom + '/' + dirigeant + '/' + date + '/' + code + '/' + siren + '/' + forme + '/' + capital + '/' + effectif + '/' +
      implantation + '/' + genre + '/' + categ + '/' + commentaire + '/' + premierTel + '/' + deuxiemeTel + '/' + email + '/' + rue +
      '/' + complement + '/' + bpostal + '/' + cpostal + '/' + ville + '/' + pays + '/' + premierURL + '/' + deuxiemeURL,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getListesOrganisationsRecherche(recherche: Array<any>, page) {
    const content = recherche[0];
    let type = recherche[1];
    const headers = this.initOptionHeader();
    type = removeAccents(type.toLowerCase());
    if (type === 'tous') {
      return this.http.get(this.listeOrganisationUrl + '?several_all=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'nom') {
      return this.http.get(this.listeOrganisationUrl + '?liste_organisation_nom=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'commentaire') {
      return this.http.get(this.listeOrganisationUrl + '?liste_organisation_comment=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
  }
  supprimerAssoListeOrganisation(assoId) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeOrganisationAssoUrl + '/' +  assoId,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  supprimerListeOrganisation(id) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeOrganisationUrl + '/' +  id,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }
  supprimerImportListeOrganisationIntranet(ancienIdListe) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '/importation/supprimer/copie/liste/organisation/' + ancienIdListe ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  getOrganisationsListeAssociees(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.organisationUrl + '?listeOrganisationOrganisations.listeOrganisation.id=' + listeId + '&order[date]=desc&pagination=false', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  modifierListeOrganisation(listeOrganisation) {
    listeOrganisation.modification = new Date();
    const DateModif = listeOrganisation.modification.getFullYear() + '-' + (listeOrganisation.modification.getMonth() + 1).toString() + '-' + listeOrganisation.modification.getDate() + ' ' + listeOrganisation.modification.getHours() + ':' + listeOrganisation.modification.getMinutes() + ':00' ;
    const headers = this.initOptionHeader();
    return this.http.put(this.listeOrganisationUrl + '/' +  listeOrganisation.id, {'nom': listeOrganisation.nom,
        'commentaires': listeOrganisation.commentaires, 'modification' : DateModif},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllListesOrganisationsPar() {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '?order[nom]=asc&pagination=false', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getOneAssoOrganisationListe(listeId, organisationId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationAssoUrl + '?listeOrganisation.id=' + listeId + '&organisation.id=' + organisationId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  associerListeOrganisation(listeId, organisationAncienId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeOrganisationUrl + '/associer/intranet/liste/organisation/' + listeId + '/' + organisationAncienId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  private errorHandler(err: any): Promise<any> {
    return Promise.reject(err.message || err );
  }
  private initOptionHeader() {
    const token: any = localStorage.getItem('auth-tokens');
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Auth-Token', token);
    return headers;
  }
}
